import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  getLocations: false,
  getTournamentPluginsSellingPrice: false,
  getTargetPlugins: false,
};

const Glossary = {
  getLocations: () => {
    if (debugStatus.getLocations) {
      return fakeApiHelper(200, 'success', {
        data: [],
        error: false,
        message: 'Get locations successfully',
      });
    }

    return ApiService.get(`/api/locations`);
  },

  getTournamentPluginsSellingPrice: () => {
    if (debugStatus.getTournamentPluginsSellingPrice) {
      return fakeApiHelper(200, 'success', {
        data: {
          currency: 'NTD',
          open_registration: {
            list_price: 4500.0,
            retail_price: 3999.0,
          },
          expand_media_space: {
            list_price: 3000.0,
            retail_price: 2499.0,
          },
          paper_record_online: {
            list_price: 1000.0,
            retail_price: 1000.0,
          },
          offline_commissioner: {
            list_price: 1000.0,
            retail_price: 1000.0,
          },
        },
        error: false,
        message: 'Update player verified teams successfully',
      });
    }

    return ApiService.get(`/api/plugins/tournament`);
  },

  getTargetPlugins: ({ target }) => {
    return ApiService.get(`/api/plugins/${target}`);
  },
};

export default Glossary;
